module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"onlineInterviewNotPassed":"The candidate has not yet completed an online interview","offlineInterviewNotPassed":"The candidate has not yet completed an in-person interview"}}')
  delete Component.options._Ctor
}
